import styled, { css } from 'styled-components';
import {
  boxShadow,
  hoverBoxShadow,
} from '../../styles/constants';

const Card = styled.div`
  background-color: white;
  border-radius: 5px;
  padding: 1rem;
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  box-shadow: ${(props) => (props.$selected ? '0 0 0 2pt #00a050' : boxShadow)};

  ${(props) => props.selectable && css`
    cursor: pointer;
    
    :hover {
      box-shadow: ${!props.$selected && hoverBoxShadow};
    }
  `};
`;

export default Card;
